<template>
	<section>	
		<ul class="progressbar">
			<li :class="step == 'info' ? 'active' : 'done'">Info</li>
			<li :class="step == 'info-barang' ? 'active' : '' || step == 'preview' ? 'done' : ''">Info Barang</li>
			<li :class="step == 'preview' ? 'active' : ''" style="min-width: 129px;">Preview Pengiriman</li>
		</ul>

		<hr class="mt-5 mb-4 hide-on-mobile">
		<hr class="mt-4 mb-4 hide-on-web">	

		<section v-show="step == 'info'">
			<ValidationObserver tag="form" ref="val1">
				<form @submit.prevent="setStep('info-barang')">
					<p class="f-14 f-m-12 margin-0">
						<strong class="row">Nomor Resi 
							<div class="mr-4 ml-4">:</div>
							{{ model.no_resi }}
						</strong>
					</p>
					<div class="row">
						<div class="form-group mt-3 col margin-0">
							<label class="form-label">Nomor faktur (Optional)</label>
							<ValidationProvider name="model.no_faktur">
								<input type="text" v-model="model.no_faktur" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor faktur" slot-scope="{ errors }">
							</ValidationProvider>                          
						</div>
						<div class="col"></div>
					</div>    
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Rute Pengiriman</strong></p>
					<div class="row">
						<div class="form-group mt-3 col margin-0">
							<label class="form-label">Rute pengiriman</label>
							<ValidationProvider name="model.id_rute" rules="required">
								<model-list-select class="form-control f-12"
									:list			= params.rute
									:class			="{ 'error': errors[0] }"
									v-model			= model.id_rute
									option-value	= "id"
									option-text		= "col_rute"
									placeholder		= "Pilih rute pengiriman"									
									slot-scope		="{ errors }">
								</model-list-select>   
							</ValidationProvider>                
						</div>
						<div class="col"></div>
					</div>    
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Data Penerima</strong></p>
					<div class="row">
						<div class="form-group col ml-0 mr-2 m-m-0">
							<label class="form-label">Nama</label>
							<ValidationProvider name="model.name_receive" rules="required">
								<vue-autosuggest
									v-model					= model.name_receive
									:suggestions			= suggestPelanggan
									:get-suggestion-value	= formattedDisplay
									:input-props			="{class: 'form-control', placeholder:'Masukkan nama'}"
									:class					="{ 'error': errors[0] }"
									@input					= searchNamaPelanggan
									@selected				= selectedPelangganReceive									
									slot-scope				="{ errors }">
									<template slot-scope="{suggestion}">
										<div class="row">
											<span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.name}} </span>
											<span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.address}} </span>
										</div>								
									</template>
								</vue-autosuggest>
							</ValidationProvider> 

							<label class="form-label mt-2">Nomor telepon</label>
							<ValidationProvider name="model.phone_number_receive" rules="required">
								<input :disabled="disabledReceive == 1" type="text" v-model="model.phone_number_receive" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor telepon" slot-scope="{ errors }">
							</ValidationProvider>

							<label class="form-label mt-2">Negara</label>
							<SelectOption :disabled="disabledReceive == 1" placeholder="Cari Negara" url="country" label="country_name" keyId="id_country_receive" :defaultId="model.id_country_receive" @setValue="setValueCountryReceive"/>
						</div>
						<div class="col m-m-0">
							<div class="row">
								<div class="form-group mt-0 col ml-0 mr-0 mb-0">
									<label class="form-label">Kota atau kecamatan</label>									
									<SelectOption :disabled="disabledReceive == 1" placeholder="Cari Kota atau kecamatan" url="location" label="kabupaten" keyId="id_location" :defaultId="model.id_location_receive" @setValue="setValueLocationReceive"/>
								</div>
								<div class="form-group mt-0 col-4 w-m-full no-flex mr-0 ml-m-0">
									<ValidationProvider name="model.id_kodepos_receive" rules="required">
										<label class="form-label">Kode pos</label>
										<select v-model="model.id_kodepos_receive" class="form-control" :disabled="disabledReceive == 1">
											<option value="0">Pilih Kode Pos</option>
											<option v-for="(data, index) in listKodeposReceive" v-bind:value="data.id" :key="index">
												{{ data.kodepos }}
											</option>
										</select>
									</ValidationProvider>
								</div>
							</div>
							<div class="form-group ">
								<label class="form-label">Alamat Lengkap</label>
								<ValidationProvider name="model.address_receive" rules="required">
									<input :disabled="disabledReceive == 1" type="text" v-model="model.address_receive" class="form-control" :class="{ 'error': errors[0] }" placeholder="Nama jalan, nomor rumah, gedung, dsb." slot-scope="{ errors }">
								</ValidationProvider>
							
								<label class="form-label mt-2">Kordinat lokasi (optional) <a data-toggle="modal" href="#modalPilihKordinatReceive" class="link"> Pilih Kordinat</a></label>								
								<GmapMap
										class		= "maps mb-2"
										style		= "height: 150px"
										:center		= map.center_receive
										:options	= mapOptions 
										:zoom		= map.zoom_receive 								
										@click		= addMarkerReceive 
								>
									<gmap-marker
											v-for="(item, index) in markers_receive"
											:key="index"
											:position="item"
									/>
								</GmapMap>
								<p class="f-14"><b>{{ map.address_receive }} </b><a href="javascript:;" class="link float-right" @click="delKoorReceive">Hapus Kordinat</a></p>
							</div>            
						</div>  
					</div>    
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Data Pengirim</strong></p>
					<div class="row">
						<div class="form-group col ml-0 mr-2 m-m-0">
							<label class="form-label">Nama</label>
							<ValidationProvider name="model.name_shipper" rules="required">
								<vue-autosuggest
									v-model					= model.name_shipper
									:suggestions			= suggestPelanggan
									:get-suggestion-value	= formattedDisplay
									:input-props			="{class: 'form-control', placeholder:'Masukkan nama'}"
									@input					= searchNamaPelanggan
									@selected				= selectedPelangganShipper
									:class="{ 'error': errors[0] }"
									slot-scope="{ errors }">
									<template slot-scope="{suggestion}">
										<div class="row">
											<span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.name}} </span>
											<span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.address}} </span>
										</div>								
									</template>
								</vue-autosuggest>
							</ValidationProvider>

							<label class="form-label mt-2">Nomor telepon</label>
							<ValidationProvider name="model.phone_number_shipper" rules="required">
								<input type="text" :disabled="disabledShipper == 1" v-model="model.phone_number_shipper" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nomor telepon" slot-scope="{ errors }">
							</ValidationProvider>

							<label class="form-label mt-2">Negara</label>							
							<SelectOption :disabled="disabledShipper == 1" placeholder="Cari Negara" url="country" label="country_name" keyId="id_country_shipper" :defaultId="model.id_country_shipper" @setValue="setValueCountryShipper"/>	
						</div>
						<div class="col m-m-0">
							<div class="row">
								<div class="form-group mt-0 col ml-0 mr-0 mb-0">
									<label class="form-label">Kota atau kecamatan</label>									
									<SelectOption :disabled="disabledShipper == 1" placeholder="Cari Kota atau kecamatan" url="location" label="kabupaten" keyId="id_location" :defaultId="model.id_location_shipper" @setValue="setValueLocationShipper"/>									
								</div>
								<div class="form-group mt-0 col-4 w-m-full no-flex mr-0 ml-m-0">
									<ValidationProvider name="model.id_kodepos_shipper" rules="required">
										<label class="form-label">Kode pos</label>
										<select v-model="model.id_kodepos_shipper" class="form-control" :disabled="disabledShipper == 1">
											<option value="0">Pilih Kode Pos</option>
											<option v-for="(data, index) in listKodeposShipper" v-bind:value="data.id" :key="index">
												{{ data.kodepos }}
											</option>
										</select>
									</ValidationProvider>
								</div>
							</div>
							<div class="form-group ">
								<label class="form-label">Alamat Lengkap</label>
								<ValidationProvider name="model.address_shipper" rules="required">
									<input type="text" :disabled="disabledShipper == 1" v-model="model.address_shipper" class="form-control" :class="{ 'error': errors[0] }" placeholder="Nama jalan, nomor rumah, gedung, dsb." slot-scope="{ errors }">
								</ValidationProvider>
							
								<label class="form-label mt-2">Kordinat lokasi (optional) <a data-toggle="modal" href="#modalPilihKordinatShipper" class="link"> Pilih Kordinat</a></label>								
								<GmapMap
										class		="maps mb-2"
										:center		= map.center_shipper
										:options	= mapOptions
										:zoom		= map.zoom_shipper
										style		="height: 150px"
										@click		= addMarkerShipper
								>
									<gmap-marker
											v-for="(item, index) in markers_shipper"
											:key="index"
											:position="item"
									/>
								</GmapMap>
								<p class="f-14"><b>{{ map.address_shipper }} </b><a href="javascript:;" class="link float-right" @click="delKoorShipper">Hapus Kordinat</a></p>
							</div>            
						</div>  
					</div> 
					<hr>
					<button type="submit" class="w-m-1-2 float-right btn btn-primary col-2 mb-3 pd-10-20 text-white">Selanjutnya</button>
				</form>
			</ValidationObserver>
		</section>
		<section v-show="step == 'info-barang'">
			<ValidationObserver tag="form" ref="val2">
				<form @submit.prevent="setStep('preview')">
					<p class="f-14 f-m-12"><strong>Info Barang </strong><br><i>(Jika packing barang berbeda harap masukkan info barang secara terpisah)</i></p>
					<div class="row" v-for="(barang, index) in model.info_barang.barangs" v-bind:key="index">
						<div class="col w-m-full no-flex">
							<div class="form-group col">
								<label class="form-label">Nama barang</label>
								<ValidationProvider name="model.address_receive" rules="required">
									<input type="text" class="form-control" :class="{ 'error': errors[0] }" placeholder="Masukkan nama barang" v-model="barang.nama" slot-scope="{ errors }">
								</ValidationProvider>
							</div>
						</div>
						<div class="col">
							<div class="row">
								<div class="form-group col w-m-1-4">
									<label class="form-label">Berat (kg)</label>
									<ValidationProvider rules="required|min_value:1">
										<input type="text" class="form-control" placeholder="0 Kg" v-model="barang.berat" @change="setTotalHarga" slot-scope="{ errors }" :class="{ 'error': errors[0]}">
									</ValidationProvider>
								</div>
								<div class="form-group col w-m-1-4">
									<label class="form-label">Panjang (cm)</label>
									<ValidationProvider rules="required|min_value:1">
										<input type="text" class="form-control" placeholder="0 cm" v-model="barang.panjang" @change="setTotalHarga" slot-scope="{ errors }" :class="{ 'error': errors[0]}">
									</ValidationProvider>
								</div>
								<div class="form-group col w-m-1-4">
									<label class="form-label">Lebar (cm)</label>
									<ValidationProvider rules="required|min_value:1">
										<input type="text" class="form-control" placeholder="0 cm" v-model="barang.lebar" @change="setTotalHarga" slot-scope="{ errors }" :class="{ 'error': errors[0]}">
									</ValidationProvider>
								</div>
								<div class="form-group col w-m-1-4">
									<label class="form-label">Tinggi (cm)</label>
									<ValidationProvider rules="required|min_value:1">
										<input type="text" class="form-control" placeholder="0 cm" v-model="barang.tinggi" @change="setTotalHarga" slot-scope="{ errors }" :class="{ 'error': errors[0]}">
									</ValidationProvider>
								</div>
								<div class="form-group col">
									<label class="form-label">&nbsp;</label><br>
									<a class="btn btn-danger mt-1 text-white" @click="destroyBarang(index)" v-if="model.info_barang.barangs.length > 1"><span><i class="fas fa-trash"></i></span></a>
									<a class="btn btn-warning text-white bg-prim ml-2 mt-1" @click="addBarang" v-if="index == model.info_barang.barangs.length - 1"><span><i class="fas fa-plus-circle"></i></span></a>
								</div>
							</div>
						</div>
					</div>
					<hr>
					<p class="f-14"><strong>Keterangan Tambahan</strong></p>
					<div class="col-6">
						<div class="form-group">
							<label class="form-label">Keterangan</label>
							<input type="text" class="form-control" placeholder="Tambahkan keterangan tambahan. contoh (jangan dibanting, dsb)" v-model="model.info_barang.keterangan_tambahan">
						</div>
					</div>
					<hr>
					<p class="f-14"><strong>Total Harga Pengiriman</strong></p>
					<div class="col-6">
						<div class="form-group">
							<label class="form-label">Sub Total</label>    							
							<vue-numeric class="form-control" currency="Rp" separator="." label="harga" name="harga" v-model="subtotal" placeholder="Rp 0"></vue-numeric>

							<label class="form-label mt-4">Potongan Harga (%)</label>
							<!-- <input type="text" class="form-control" placeholder="Masukkan potongan harga (Persentase)">  -->
							<ValidationProvider rules="min_value:0|max_value:100|numeric">
								<div class="input-group" :class="{ 'error': errors[0] }" slot-scope="{ errors }">
									<input type="text" class="form-control"  placeholder="Masukkan potongan harga" v-model="model.info_barang.disc" @change="setTotalHarga">									
									<div class="input-group-append">
										<span class="input-group-text" id="basic-addon2"><b>%</b></span>
									</div>
								</div>
							</ValidationProvider>	

							<label class="form-label mt-4">Total Potongan</label>    
							<vue-numeric class="form-control" currency="Rp" separator="." label="harga" name="harga" v-model="potongan" placeholder="Rp 0"></vue-numeric>						

							<label class="form-label mt-4">Total Harga</label>    
							<vue-numeric class="form-control" currency="Rp" separator="." label="harga" name="harga" v-model="model.info_barang.total_harga" placeholder="Rp 0"></vue-numeric>
						</div>
					</div>
					<hr>
					<div class="row float-right w-1-4 w-m-full mb-4">
						<a @click="step = 'info'" class="col btn btn-secondary margin-5 pd-10-20 c-prim">Kembali</a>
						<button type="submit" class="col btn btn-primary margin-5 pd-10-20 text-white">Selanjutnya</button>    
					</div> 
				</form>
			</ValidationObserver>
		</section>
		<section v-show="step == 'preview'">
			<div class="row mb-4">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Nomor Resi</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<b>{{ model.no_resi }}</b>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Nomor Faktur</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<b>{{ model.no_faktur }}</b>
						</div>
					</div>
				</div>
			</div>
			<hr class="mt-4 mb-4">
			<div class="row mb-4">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Rute Pengiriman</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<b>{{ rute_pengiriman.namaDataPengiriman }}</b>
						</div>
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Jenis Pengiriman</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<b>{{ (this.$route.params.type == 'kg' ? 'Kg' : 'Box') }}</b>
						</div>
					</div>
				</div>
			</div>
			<div class="row mb-4">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Total Harga</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<b>{{ model.info_barang.total_harga | currency}}</b>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Keterangan Tambahan</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<button class="info warning mb-2">{{ model.info_barang.keterangan_tambahan == '' ? "Tidak ada" : model.info_barang.keterangan_tambahan }}</button>
						</div>
					</div>
				</div>
			</div>
			<hr class="mt-4 mb-4">
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-full">
					<p class="f-14 f-m-12 margin-0"><strong>Data Penerima</strong></p>
				</div>
				<div class="col f-12">
					<div class="title-colee">Nama penerima / Perusahaan penerima</div>
					<p><strong>{{ model.name_receive }}</strong></p>

					<div class="title-colee">Nomor telepon</div>
					<p>{{ model.phone_number_receive }}</p>

					<div class="title-colee">Alamat</div>
					<p>
						{{ model.address_receive }}
					</p>
					<p>Kordinat Lokasi (optional)</p>
					<GmapMap
							class="maps mb-2"
							:center="map.center_receive"
							:options="mapOptions"
							:zoom="map.zoom_receive"
							style="height: 150px"
					>
						<gmap-marker
								v-for="(item, index) in markers_receive"
								:key="index"
								:position="item"
						/>
					</GmapMap>
					<p class="f-14"><strong>{{ map.address_receive }}</strong></p>
				</div>
			</div>
			<hr class="mt-4 mb-4">
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-full">
					<p class="f-14 f-m-12 margin-0"><strong>Data Pengirim</strong></p>
				</div>
				<div class="col f-12">
					<div class="title-colee">Nama penerima / Perusahaan penerima</div>
					<p><strong>{{ model.name_shipper }}</strong></p>

					<div class="title-colee">Nomor telepon</div>
					<p>{{ model.phone_number_shipper }}</p>

					<div class="title-colee">Alamat</div>
					<p>{{ model.address_shipper }}</p>
					<p>Kordinat Lokasi (optional)</p>
					<GmapMap
							class="maps mb-2"
							:center="map.center_shipper"
							:options="mapOptions"
							:zoom="map.zoom_shipper"
							style="height: 150px"
					>
						<gmap-marker
								v-for="(item, index) in markers_shipper"
								:key="index"
								:position="item"
						/>
					</GmapMap>
					<p class="f-14"><strong>{{ map.address_shipper }}</strong></p>
				</div>
			</div>
			<hr class="mt-4 mb-4">
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-full">
					<p class="f-14 f-m-12 margin-0"><strong>Info Barang</strong></p>
				</div>
				<div class="col f-12">
					<div class="row">
						<div class="heuheuheuheu" v-for="(barang, index) in model.info_barang.barangs" v-bind:key="index">
							<div class="title-colee">Nama Barang</div>
							<p>{{ barang.nama }}</p>
							<div class="title-colee">Berat</div>
							<p>{{ barang.berat }}KG</p>
							<div class="title-colee">Panjang x Lebar x Tinggi</div>
							<p class="mb-0">{{ barang.panjang }}cm x {{ barang.lebar }}cm x {{ barang.tinggi }}cm</p>
							<!-- <hr>
							<p class="text-danger mb-0">*Berat volumetrik <b>(21KG)</b></p> -->
						</div>
					</div>
					<div class="mt-2 col-9 w-m-full" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:5px 10px;">
						<div class="row ">
							<div class="col">
								<p class="title-colee">Total Barang</p>
								<b>{{ model.info_barang.barangs.length }}</b>
							</div>
							<div class="col">
								<p class="title-colee">Total Berat</p>
								<b>{{ model.info_barang.total_berat_bersih }}KG</b>
							</div>
							<div class="col">
								<p class="title-colee">Volume</p>
								<b>{{ model.info_barang.total_volume }} m3</b>
							</div>
						</div>    
					</div> 
				</div>
			</div>
			<hr class="mt-4 mb-4">
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Keterangan Tambahan</strong></p>
				</div>
				<div class="mt-2 f-12" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
					{{ model.info_barang.keterangan_tambahan == '' ? "Tidak ada" : model.info_barang.keterangan_tambahan}}
				</div>
			</div>
			<hr>
			<div class="row float-right w-1-4 w-m-full mb-4">
				<a @click="step = 'info-barang'" class="col btn btn-secondary margin-5 pd-10-20 c-prim">Kembali</a>
				<button data-toggle="modal" data-target="#modalConfirmPreview" class="col btn btn-primary margin-5 pd-10-20">Selanjutnya</button> 
			</div> 
		</section>

		<div class="modal fade" id="modalPilihKordinatReceive" tabindex="-1" role="dialog" aria-labelledby="modalPilihKordinatTitle" aria-hidden="true">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Pilih Kordinat</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                </p>
		                <div class="mt-2 f-14" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
		                    Pastikan lokasi yang kamu pilih tidak berbeda jauh dengan alamat yang kamu isi di kolom alamat.
		                </div>
		                <!-- <div class="mt-4 mb-4 maps"></div> -->
						<gmap-autocomplete
								@place_changed="setPlaceReceive"
								class="form-control"
						>
						</gmap-autocomplete>
						<GmapMap
								class		= "maps mb-2"
								style		= "height: 330px"
								:center		= map.center_receive
								:options	= mapOptions 
								:zoom		= map.zoom_receive 								
								@click		= addMarkerReceive 
						>
							<gmap-marker
									v-for="(item, index) in markers_receive"
									:key="index"
									:position="item"
							/>
						</GmapMap>
						<p class="f-14"><b>{{ map.address_receive }} </b></p>
		                <button type="button" class="float-right btn btn-primary col-2 w-m-1-2 mt-2 margin-5 pd-10-20" data-dismiss="modal">Simpan</button>
		            </div>
		        </div>
		    </div>
		</div>
		<div class="modal fade" id="modalPilihKordinatShipper" tabindex="-1" role="dialog" aria-labelledby="modalPilihKordinatTitle" aria-hidden="true">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Pilih Kordinat</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                </p>
		                <div class="mt-2 f-14" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
		                    Pastikan lokasi yang kamu pilih tidak berbeda jauh dengan alamat yang kamu isi di kolom alamat.
		                </div>		                
						<gmap-autocomplete
								@place_changed="setPlaceShipper"
								class="form-control"
						>
						</gmap-autocomplete>
						<GmapMap
								class		= "maps mb-2"
								style		= "height: 330px"
								:center		= map.center_shipper
								:options	= mapOptions 
								:zoom		= map.zoom_shipper							
								@click		= addMarkerShipper 
						>
							<gmap-marker
									v-for="(item, index) in markers_shipper"
									:key="index"
									:position="item"
							/>
						</GmapMap>
						<p class="f-14"><b>{{ map.address_shipper }} </b></p>
		                <button type="button" class="float-right btn btn-primary col-2 w-m-1-2 mt-2 margin-5 pd-10-20" data-dismiss="modal">Simpan</button>
		            </div>
		        </div>
		    </div>
		</div>
		<div class="modal fade" id="modalConfirmPreview" tabindex="-1" role="dialog" aria-labelledby="modalConfirmPreviewTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content mx-auto">
					<div class="modal-body text-center">
						<p>Data akan disimpan apa anda juga ingin mencetak barcode pengiriman ini?</p>
						<div class="row justify-content-center">
							<a @click="createPelanggan(0)" class="margin-5 btn btn-secondary pd-10-20 c-prim">Nanti Saja</a>
							<a @click="createPelanggan(1)" class="margin-5 btn btn-primary pd-10-20 text-white">Ya</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import SelectOption from './SelectOption'
import Vue from "vue"

export default {
	name: 'Form',
	components: {
		SelectOption
	},
	data() {
		return {
			model: {
				id_rute: '',
				no_resi: '',
				no_faktur: '',
				name_shipper: '',
                phone_number_shipper: '',
                address_shipper: '',
                name_receive: '',
                phone_number_receive: '',
                address_receive: '',
				id_country: '',
				id_location: '',
				info_barang: {
				    keterangan_tambahan: '',
					total_harga: '',
					total_disc: '',
					total_berat_bersih: 0,
					total_berat_masa: 0,
					total_volume: 0,
					disc: 0,
					barangs: [
						{
						    nama: '',
							berat: '',
							panjang: '',
							lebar: '',
							tinggi: ''
						}
					]
				},
				id_kodepos_shipper: 0,
				id_kodepos_receive: 0
			},
			params : {
                rute: [],
            },
			mapOptions: {
				streetViewControl: false,
				fullscreenControl: false,
				mapTypeControl: false,
			},
            markers_receive: [],
            markers_shipper: [],
			map: {
			    address_shipper: '',
			    place_shipper: '',
                center_shipper: { lat:-2.2145852388265177, lng:117.104081069627 },
                zoom_shipper: 4,
				address_receive: '',
				place_receive: '',
				center_receive: { lat:-2.2145852388265177, lng:117.104081069627 },
				zoom_receive: 4,
			},
            rute_pengiriman: {
                namaDataPengiriman: '',
                price: '',
                col_price: ''
			},
			suggestPelanggan: [
				{
				    data: []
				}
			],
            suggestKodePos: [
                {
                    data: []
                }
            ],
			pelanggan: {
			    receive: {},
			    shipper: {},
			},
			step: 'info',
			disabledReceive: 0,
			disabledShipper: 0,		
			disabledAction: 0,
			subtotal: 0,
			potongan: 0,
			listKodeposReceive: [],
			listKodeposShipper: []
		}
	},
	beforeMount() {
		let _ = this
		_.setNoResi()

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		create(x, y, isPrint) {
			let _ = this

			let data = {
				no_resi 	: _.model.no_resi,
				no_faktur 	: _.model.no_faktur,
				id_rute 	: _.model.id_rute,
				id_penerima : x,
				id_pengirim : y,
				potongan 	: _.model.info_barang.disc,
				harga 		: _.model.info_barang.total_harga,
				keterangan 	: _.model.info_barang.keterangan_tambahan,
				type  		: _.$route.params.type == 'kg' ? 1 : 2
			}
			_.axios.post('shipment', data).then(resp => {
				$('#modalConfirmPreview').hide();	
				$('.modal-backdrop').remove();
				var hehe = _.createBarang();
				if (hehe){
					if (isPrint == 1){
						this.print()
					}
				}

				if ( resp.data.status ) {
								
					$('body').removeClass( "modal-backdrop");
					$('body').removeClass( "modal-open");
					_.$router.push({
						name: 'DeliveryIndex',
						params: {
							status: 'insert'
						}
					})						
				}
			})
			.catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})					
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}

			_.axios.patch('/shipment', update).then(resp => {
				if ( resp.data.status ) {
					_.$router.push({
						name: 'DeliveryIndex',
						params: {
							status: 'update'
						}
					})
				}
			})
			.catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		getData() {
			let _ = this
			_.axios.get('/shipment?id=' + _.$route.params.id).then(resp => {
				let getData = resp.data.data.rows
				_.model = {
					name			: getData.name,
					phone_number	: getData.phone_number,
					address			: getData.address,
					cordinat		: getData.cordinat,
					id_country		: getData.id_country,
					id_location		: getData.id_location
				}
			})
			.catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		getDataPengiriman(){
            let _ = this
            _.axios.get('/pricelist?limit=0').then(resp => {
				_.params.rute = resp.data.data.rows.data
			}).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
        },
        getRutePengiriman(){
            let _ = this
            _.axios.get('/pricelist?id=' + _.model.id_rute).then(resp => {
				_.rute_pengiriman.namaDataPengiriman 	= resp.data.data.rows.col_rute
				_.rute_pengiriman.price 				= resp.data.data.rows.price
				_.rute_pengiriman.price_box 				= resp.data.data.rows.price_box
				_.rute_pengiriman.col_price 			= resp.data.data.rows.col_price
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
        },		
		createPelanggan(isPrint){
			let _ = this

			let dataReceive = {
                id_country		: _.model.id_country_receive,
                id_location		: _.model.id_location_receive,
                name			: _.model.name_receive,
                phone_number	: _.model.phone_number_receive,
                address			: _.model.address_receive,
				lat				: _.model.lat_receive,
				lng				: _.model.lng_receive,
				id_kodepos      : _.model.id_kodepos_receive
			}

			let dataShipper = {
				id_country		: _.model.id_country_shipper,
                id_location		: _.model.id_location_shipper,
                name			: _.model.name_shipper,
                phone_number	: _.model.phone_number_shipper,
                address			: _.model.address_shipper,
				lat				: _.model.lat_shipper,
				lng				: _.model.lng_shipper,
				id_kodepos      : _.model.id_kodepos_shipper
			}

			if (_.disabledReceive == 0){
				_.axios.post('/contact', dataReceive).then(resp => {                
					_.model.id_penerima = resp.data.data.id					
					_.handling(_.model.id_penerima, _.model.id_pengirim)
				}).catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
			}
            if (_.disabledShipper == 0){
				_.axios.post('/contact', dataShipper).then(resp => {
					_.model.id_pengirim = resp.data.data.id					
					_.handling(_.model.id_penerima, _.model.id_pengirim)
				}).catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
			}    
			
			_.handling(_.model.id_penerima, _.model.id_pengirim, isPrint)
		},
		handling(x, y, isPrint){
			if (this.disabledAction == 0){
				if (x != null && y != null){
					this.create(x, y, isPrint)											
					this.disabledAction = 1
				}
			}		
		},
		addBarang() {
            let _ = this
			_.model.info_barang.barangs.push({
                nama	: '',
                berat	: '',
                panjang	: '',
                lebar	: '',
                tinggi	: ''
			})
		},
        createBarang() {
            let _ = this
			let volume = 0
            _.model.info_barang.barangs.map(function(value) {
                volume += (value.panjang * value.lebar * value.tinggi)
                _.axios.post('/item', {
                    no_resi	: _.model.no_resi,
                    name	: value.nama,
                    weight	: value.berat,
                    length	: value.panjang,
                    width	: value.lebar,
                    tall	: value.tinggi
				}).catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
            });
            _.model.info_barang.berat_volume = volume
            return true
		},
		destroyBarang(counter) {
            let _ = this
            _.model.info_barang.barangs.splice(counter, 1);
		},
		setValueCountryReceive(val) {
			let _ = this
			_.model.id_country_receive = val
		},
		setValueCountryShipper(val) {
			let _ = this
			_.model.id_country_shipper = val
		},
		setValueLocationReceive(val) {
			let _ = this
			_.model.id_location_receive = val
			this.getKodePos(val, 2)
		},
		setValueLocationShipper(val) {
			let _ = this
			_.model.id_location_shipper = val
			this.getKodePos(val, 1)
		},
		setTotalHarga(){
            let _ = this
			let berat_bersih 	= 0
			let berat_masa 		= 0
			let volume 			= 0
			
			_.model.info_barang.barangs.map(function(value) {
				berat_bersih 	+= parseFloat(value.berat)
				volume 			+= (value.panjang*value.lebar*value.tinggi) / 1000000
				berat_masa 		+= (volume*1000000) / 6000

				_.model.info_barang.total_berat_bersih 	= berat_bersih
				_.model.info_barang.total_volume 		= volume
				_.model.info_barang.total_berat_masa 	= berat_masa
			})			

			if (this.$route.params.type == 'box'){
				_.model.info_barang.total_disc 			= (_.model.info_barang.barangs.length * _.rute_pengiriman.price_box) * _.model.info_barang.disc / 100
				_.model.info_barang.total_harga 		= (_.model.info_barang.barangs.length * _.rute_pengiriman.price_box) - _.model.info_barang.total_disc							
				_.subtotal = _.model.info_barang.barangs.length * _.rute_pengiriman.price_box
				_.potongan = _.model.info_barang.total_disc
			}
			else {
				if (berat_bersih > berat_masa){				
					_.model.info_barang.total_disc 			= (berat_bersih * _.rute_pengiriman.price) * _.model.info_barang.disc / 100
					_.model.info_barang.total_harga 		= (berat_bersih * _.rute_pengiriman.price) - _.model.info_barang.total_disc			
					// _.detailHarga = '('+ berat_bersih + "KG x " + _.rute_pengiriman.price + ") - " + _.model.info_barang.disc + '% = Rp. ' + _.model.info_barang.total_harga
					_.subtotal = berat_bersih * _.rute_pengiriman.price
					_.potongan = _.model.info_barang.total_disc
				}else{				
					_.model.info_barang.total_disc 			= (berat_masa * _.rute_pengiriman.price) * _.model.info_barang.disc / 100
					_.model.info_barang.total_harga 		= (berat_masa * _.rute_pengiriman.price) - _.model.info_barang.total_disc
					// _.detailHarga = '(('+ volume + "cm3 / 6000) x " + _.rute_pengiriman.price + ") - " + _.model.info_barang.disc + '% = Rp. ' + _.model.info_barang.total_harga
					_.subtotal = berat_masa * _.rute_pengiriman.price
					_.potongan = _.model.info_barang.total_disc
				}	
			}					
		},
        setPlaceReceive(place){
		    let _ = this
			let latLng = {
                lat: parseFloat(place.geometry.location.lat()),
                lng: parseFloat(place.geometry.location.lng()),
			}
			_.map.place_receive 	= place
            _.markers_receive 		= [latLng]
			_.map.center_receive 	= latLng
			_.map.zoom_receive 		= 18

            Vue.$geocoder.send(latLng,
                response => {
                    _.map.address_receive = response.results[0].formatted_address
				})
				
			_.model.lat_receive = parseFloat(place.geometry.location.lat())
			_.model.lng_receive = parseFloat(place.geometry.location.lng())
		},
        setPlaceShipper(place){
		    let _ = this
            let latLng = {
                lat: parseFloat(place.geometry.location.lat()),
                lng: parseFloat(place.geometry.location.lng()),
            }
			_.map.place_shipper 	= place
            _.markers_shipper 		= [latLng]
            _.map.center_shipper 	= latLng
            _.map.zoom_shipper 		= 18

            Vue.$geocoder.send(latLng,
                response => {
                    _.map.address_shipper = response.results[0].formatted_address
				})
			
			_.model.lat_shipper = parseFloat(place.geometry.location.lat())
			_.model.lng_shipper = parseFloat(place.geometry.location.lng())
		},		
		addMarkerReceive(data) {
		    let _ = this
			_.markers_receive = [{
                lat: parseFloat(data.latLng.lat()),
                lng: parseFloat(data.latLng.lng()),
			}]

            Vue.$geocoder.send({
                    lat: parseFloat(data.latLng.lat()),
                    lng: parseFloat(data.latLng.lng()),
				},
                response => {
                    _.map.address_receive = response.results[0].formatted_address
				})
			
			_.model.lat_receive = parseFloat(data.latLng.lat())
			_.model.lng_receive = parseFloat(data.latLng.lng())
		},
        delKoorReceive() {
            let _ 					= this
            _.markers_receive 		= []
			_.map.address_receive 	= ''
			_.model.lat_receive		= null
			_.model.lng_receive		= null
		},
        addMarkerShipper(data) {
            let _ = this
            _.markers_shipper = [{
                lat: parseFloat(data.latLng.lat()),
                lng: parseFloat(data.latLng.lng()),
            }]

            Vue.$geocoder.send({
                    lat: parseFloat(data.latLng.lat()),
                    lng: parseFloat(data.latLng.lng()),
                },
                response => {
                    _.map.address_shipper = response.results[0].formatted_address
				})
			
			_.model.lat_shipper = parseFloat(data.latLng.lat())
			_.model.lng_shipper = parseFloat(data.latLng.lng())
        },
        delKoorShipper() {
            let _ 					= this
            _.markers_shipper 		= []
			_.map.address_shipper 	= ''
			_.model.lat_shipper		= null
			_.model.lng_shipper		= null
        },		        
        searchNamaPelanggan(input) {
		    let _ = this
			_.axios.get('/contact?key=' + input).then(resp => {
                _.suggestPelanggan[0].data = resp.data.data.rows.data
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
        formattedDisplay(result) {
		    return result.item.name
		},
        selectedPelangganReceive(result) {
		    let _ 							= this
			let item 						= result.item
			_.model.name_receive			= item.name
			_.model.id_penerima				= item.id
		    _.model.phone_number_receive 	= item.phone_number
			_.model.address_receive 		= item.address
		    _.model.id_country_receive 		= item.id_country
			_.model.id_location_receive 	= item.id_location			
			_.model.id_kodepos_receive 		= item.id_kodepos
			_.disabledReceive 				= 1		
			
			_.getKodePos(item.id_location, 2)
			
			if(item.lat != null && item.lng != null){
				var latLng = {
					lat: parseFloat(item.lat),
					lng: parseFloat(item.lng)
				}

				_.markers_receive 		= [latLng]
				_.map.center_receive 	= latLng
				_.map.zoom_receive 		= 18

				Vue.$geocoder.send(latLng,
					response => {
						_.map.address_receive = response.results[0].formatted_address
					})
			}
		},
        selectedPelangganShipper(result) {
            let _ 							= this
			let item 						= result.item
			_.model.name_shipper			= item.name
			_.model.id_pengirim				= item.id
            _.model.phone_number_shipper	= item.phone_number
            _.model.address_shipper 		= item.address
            _.model.id_country_shipper 		= item.id_country
			_.model.id_location_shipper 	= item.id_location			
			_.model.id_kodepos_shipper 		= item.id_kodepos
			_.disabledShipper 				= 1								
			
			if(item.lat != null && item.lng != null){
				var latLng = {
					lat: parseFloat(item.lat),
					lng: parseFloat(item.lng)
				}

				_.markers_shipper 		= [latLng]
				_.map.center_shipper 	= latLng
				_.map.zoom_shipper 		= 18

				Vue.$geocoder.send(latLng,
					response => {
						_.map.address_shipper = response.results[0].formatted_address
					})
			}
        },
		setNoResi() {
			let _ = this
			var dateObj = new Date();
			var month 	= dateObj.getUTCMonth() + 1;
			var day 	= dateObj.getUTCDate();
			var year 	= dateObj.getUTCFullYear();

			var newdate = '' + year + month + day;

			var aliases = localStorage.getItem('alias');

			_.model.no_resi = aliases + newdate + Math.floor(Math.random() * 90000)
		},
		async setStep(x) {
			let _ 	= this
			
			if (x == 'info-barang'){
				const isValid = await this.$refs.val1.validate();
				if (!isValid) { 
					return;
				}
				_.step = x
			}
			if (x == 'preview'){
				const isValid2 = await this.$refs.val2.validate();
				if (!isValid2) { 
					return;
				}
				_.step = x
			}
		},
		print() {
			let _ = this

			if(localStorage.getItem('bluetooth_print') == 'true') {
                _.axios.get('/shipment/print?format=png&no_resi=' + _.model.no_resi, {responseType: 'arraybuffer'})
                    .then(resp => {
                        let blob    = new Blob([resp.data], { type: 'image/png' })
                        
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);

                        reader.onloadend = function(e) {
                            var imageBase64 = e.target.result.split(',')[1];
                            var intentUrl = "intent://print?package=com.app.bisacekprint&image=" + encodeURIComponent(imageBase64) + "#Intent;scheme=bisacekprint;end";
                            window.location.href = intentUrl;
                        };
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
            else {
                _.axios.get('/shipment/print?no_resi=' + _.model.no_resi, {responseType: 'arraybuffer'})
                    .then(resp => {
                        let blob    = new Blob([resp.data], { type: 'application/pdf' })
                        let link    = document.createElement('a')
                        link.href   = window.URL.createObjectURL(blob)
                        link.target = "_blank"
                        // link.download = 'QRCODE_' +_.model.no_resi
                        link.click()
                    })
                    .catch(err => {
                        console.log(err.response)
                    })
            }
		},
		getKodePos(id, type){
			let _ = this			
			_.axios.get('location?id=' + id )
				.then(resp => {
					if (type == 1){
						this.listKodeposShipper = resp.data.data.rows.kodepos												
					}else{
						this.listKodeposReceive = resp.data.data.rows.kodepos						
					}
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})			
		},
	},
	watch: {
		'model.id_rute': function () {
			this.getRutePengiriman()			
		}
	},
	created(){
        let _ = this
		_.getDataPengiriman()
    },
}
</script>